import React, { useEffect, useState, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import useAuth from './useAuth';
import EmployeeHeader from '../components/EmployeeHeader';

export default function MonthlyDutyRoster() {
     useAuth();
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [showModal, setShowModal] = useState(false);
     const [showOtherModal, setShowOtherModal] = useState(false);
     const role = sessionStorage.getItem('user_role');
     const [loading, setLoading] = useState(false);
     const getCurrentMonth = () => {
          const d = new Date();
          return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
     };

     const getNextMonth = () => {
          const d = new Date();
          d.setMonth(d.getMonth() + 1);
          return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
     };

     const [month, setMonth] = useState(getCurrentMonth());

     const handleSubmit = async (e) => {
          e.preventDefault();

          setLoading(true);

          const payload = {
               auto: true,
               month,
          };

          try {
               const response = await fetch(
                    `${baseUrl}/autoGenerateDutyRosterBulk`,
                    {
                         method: "POST",
                         headers: {
                              "Content-Type": "application/json",
                         },
                         body: JSON.stringify(payload),
                    }
               );

               if (!response.ok) {
                    throw new Error("Server Error");
               }

               const result = await response.json();

               alert(result.message);

               setShowModal(false);

          } catch (err) {
               console.error(err);
               alert(err.message);
          } finally {
               setLoading(false);
          }
     };

     const handleOtherSubmit = async (e) => {
          e.preventDefault();

          setLoading(true);

          const payload = {
               auto: true,
               month,
          };

          try {
               const response = await fetch(
                    `${baseUrl}/autoGenerateDutyRosterForContractEmployee`,
                    {
                         method: "POST",
                         headers: {
                              "Content-Type": "application/json",
                         },
                         body: JSON.stringify(payload),
                    }
               );

               if (!response.ok) {
                    throw new Error("Server Error");
               }

               const result = await response.json();

               alert(result.message);

               setShowModal(false);

          } catch (err) {
               console.error(err);
               alert(err.message);
          } finally {
               setLoading(false);
          }
     };

     return (
          /* if role is SUPER_ADMIN continue else show message "You do not have permission to view this page." */
          role === 'SUPER_ADMIN' ? (
               <div className="employee-master-page">
                    <div className="employee-header">
                         <h2>Monthly Duty Roster</h2>
                    </div>
                    <div className="employee-content">
                         {/* buttons to open modal for contractual employees, doctors */}
                         <button
                              onClick={() => {
                                   // open modal
                                   setShowOtherModal(true);
                              }}

                              style={{ marginRight: "10px", color: "#0560b4", fontWeight: "bold", fontSize: "14px", backgroundColor: "white", border: "1px solid important" }} className="btn btn-sm mr-2 ">Generate Monthly Duty Roster for Contractual Employees </button>
                         <button
                              onClick={() => {
                                   // open modal
                                   setShowModal(true);
                              }}
                              style={{ marginRight: "10px", color: "#af6504", fontWeight: "bold", fontSize: "14px", backgroundColor: "white", border: "1px solid important" }} className="btn btn-sm mr-2">Generate Monthly Duty Roster for Doctors</button>

                         {loading && (
                              <div className="text-center mt-3">
                                   <div className="spinner-border text-primary" role="status"></div>
                                   <p className="mt-2">
                                        Generating duty roster...
                                        <br />
                                        This may take few minutes.
                                   </p>
                              </div>
                         )}
                         {/* Modal (controlled by React state instead of jQuery) modal show in center of page */}
                         <div
                              className={`modal fade ${showModal ? "show d-block" : ""}`}
                              tabIndex="-1"
                              style={{
                                   background: "rgba(0,0,0,0.5)",
                              }}
                         >
                              <div className="modal-dialog modal-lg">
                                   <div className="modal-content">

                                        <form onSubmit={handleSubmit}>

                                             <div className="modal-header">
                                                  <h5 className="modal-title">
                                                       Generate Monthly Duty Roster for Doctors
                                                  </h5>

                                                  <button
                                                       type="button"
                                                       className="btn-close"
                                                       onClick={() => setShowModal(false)}
                                                  ></button>
                                             </div>

                                             <div className="modal-body px-4">
                                                  <div className="mb-3">
                                                       <label className="form-label">
                                                            Select Month
                                                       </label>

                                                       <input
                                                            type="month"
                                                            className="form-control"
                                                            value={month}
                                                            min={getCurrentMonth()}
                                                            max={getNextMonth()}
                                                            onChange={(e) =>
                                                                 setMonth(e.target.value)
                                                            }
                                                            required
                                                       />
                                                  </div>

                                             </div>

                                             <div className="modal-footer">

                                                  <button
                                                       type="button"
                                                       className="btn btn-secondary"
                                                       onClick={() => setShowModal(false)}
                                                  >
                                                       Close
                                                  </button>

                                                  <button
                                                       type="submit"
                                                       className="btn btn-primary"
                                                       disabled={loading}
                                                  >
                                                       {loading ? "Generating..." : "Save"}
                                                  </button>

                                             </div>

                                        </form>

                                   </div>
                              </div>
                         </div>

                         <div
                              className={`modal fade ${showOtherModal ? "show d-block" : ""}`}
                              tabIndex="-1"
                              style={{
                                   background: "rgba(0,0,0,0.5)",
                              }}
                         >
                              <div className="modal-dialog modal-lg">
                                   <div className="modal-content">

                                        <form onSubmit={handleOtherSubmit}>

                                             <div className="modal-header">
                                                  <h5 className="modal-title">
                                                       Generate Monthly Duty Roster for Contractual Employees
                                                  </h5>

                                                  <button
                                                       type="button"
                                                       className="btn-close"
                                                       onClick={() => setShowOtherModal(false)}
                                                  ></button>
                                             </div>

                                             <div className="modal-body px-4">
                                                  <div className="mb-3">
                                                       <label className="form-label">
                                                            Select Month
                                                       </label>

                                                       <input
                                                            type="month"
                                                            className="form-control"
                                                            value={month}
                                                            min={getCurrentMonth()}
                                                            max={getNextMonth()}
                                                            onChange={(e) =>
                                                                 setMonth(e.target.value)
                                                            }
                                                            required
                                                       />
                                                  </div>

                                             </div>

                                             <div className="modal-footer">

                                                  <button
                                                       type="button"
                                                       className="btn btn-secondary"
                                                       onClick={() => setShowOtherModal(false)}
                                                  >
                                                       Close
                                                  </button>

                                                  <button
                                                       type="submit"
                                                       className="btn btn-primary"
                                                       disabled={loading}
                                                  >
                                                       {loading ? "Generating..." : "Save"}
                                                  </button>

                                             </div>

                                        </form>

                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

          ) : (
               <div className="employee-master-page">
                    <div className="employee-header">
                         <h2>You do not have permission to view this page.</h2>
                    </div>
               </div>
          )
     );
}